import {
  LookbookSettingsCriteriaFormSkeleton,
  LookbookSettingsDeliveryWindowsField,
  LookbookSettingsFormOption,
  LookbookSettingsPricelistField,
} from '@app/components/lookbook/LookbookSettingsPage/components';
import { Form } from '@app/components/various/Form';
import { useLookbookDetails } from '@app/services/hooks/lookbook/useLookbookDetails';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const LOOKBOOK_CRITERIA_FORM_NAME = 'lookbookSettingsCriteriaForm';

interface CriteriaForm {
  lookbookDeliveryWindows: string[];
  lookbookPricelist: string[];
}

interface Props {
  lookbookId?: string;
}

export const LookbookSettingsCriteriaForm = ({ lookbookId }: Props) => {
  const { t } = useTranslation(['lookbook', 'common']);
  const formMethods = useForm<CriteriaForm>();

  const { data: lookbookSettings, isLoading: isLoadingLookbookSettings } = useLookbookDetails({ lookbookId });

  const lookbookDeliveryWindows = React.useMemo(() => lookbookSettings?.deliveryWindows ?? [], [lookbookSettings]);
  const lookbookPricelist = React.useMemo(() => lookbookSettings?.pricelists ?? [], [lookbookSettings]);

  React.useEffect(() => {
    const lookbookDeliveryWindowIds = lookbookDeliveryWindows.map(deliveryWindow => deliveryWindow.deliveryWindow);
    const lookbookPricelistIds = lookbookPricelist.map(pricelist => pricelist.id);

    formMethods.setValue('lookbookDeliveryWindows', lookbookDeliveryWindowIds);
    formMethods.setValue('lookbookPricelist', lookbookPricelistIds);
  }, [formMethods, lookbookDeliveryWindows, lookbookPricelist]);

  if (isLoadingLookbookSettings) {
    return <LookbookSettingsCriteriaFormSkeleton />;
  }

  return (
    <Form formMethods={formMethods} onSubmit={() => null} id={LOOKBOOK_CRITERIA_FORM_NAME}>
      <div className="space-y-5">
        <section className="box space-y-5">
          <h3 className="heading-3">{t('lookbook:criteria')}</h3>
          <p className="text-neutral-40 body-2">{t('lookbook:lookbook_settings_criteria_subtitle')}</p>
          <LookbookSettingsFormOption label={t('common:delivery_window_other')} isDisabled={isLoadingLookbookSettings}>
            <LookbookSettingsDeliveryWindowsField
              fieldName="lookbookDeliveryWindows"
              currentLookbookDeliveryWindows={lookbookDeliveryWindows}
            />
          </LookbookSettingsFormOption>
          <LookbookSettingsFormOption label={t('lookbook:recommended_retail_price_rrp')} isDisabled={isLoadingLookbookSettings}>
            <LookbookSettingsPricelistField fieldName="lookbookPricelist" lookbookPricelist={lookbookPricelist} />
          </LookbookSettingsFormOption>
        </section>
      </div>
    </Form>
  );
};
